var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368.31 347.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1f7244;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.17,298.93V0H186C124,11.2,62.21,21.56,0,32.31V315.05c61.21,10.81,123.2,21.62,184.8,32.82H210V298.93ZM119,236.88a476.32,476.32,0,0,1-20.27-50.74C93.13,202.55,85.4,218,79.07,234.08c-8.84,0-17.69-.5-26.54-.84,10.36-20.32,20.38-40.82,31.08-61-9.07-20.83-19.1-41.22-28.45-61.88l26.77-1.52c6,15.8,12.6,31.42,17.59,47.61,5.6-17.19,13.27-33.61,20.1-50q13.73-.95,27.5-1.68Q131,138,114.58,171.31c11.2,22.39,22.4,45.07,33.6,67.7-9.75-.79-19.43-1.4-29.18-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.36,38.75V60.2H263.2V91.84H220.36V109.2H263.2v31.64H220.36V158.2H263.2v31.59H220.36v17.35H263.2V238.5H220.36v18.37H263.2V287.5H220.36V309h148V38.75Zm115.3,249H273.39V257.1h62.27Zm0-49H273.39V207.09h62.27Zm0-49H273.39V158.15h62.27Zm0-49H273.39V109.15h62.27Zm0-49H273.39V60.2h62.27Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.62f68859b6dfa4a38c3abaa098971a9e.svg";
export { ForwardRef as ReactComponent };